import React, { useEffect, useState } from 'react'
import { MenuItem } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useTheme } from '@mui/material/styles'

const AdxMenuItem = ({ value, children, selectedvalue, icon1, icon2, sx, ...rest
}) => {
  //Props:
  // selectedvalue: string. props can be passed from the parent component to check whether the item is selected.
  const [selected, setSelected] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    if (selectedvalue === value) {
      return setSelected(true)
    } else {
      return setSelected(false)
    }
  }, [selectedvalue, value])

  return (
    <MenuItem
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        gap: 1,
        backgroundColor: selected ? `${theme.palette['primary'].light} !important` : null,
        '&.Mui-selected': {
          backgroundColor: `${theme.palette['primary'].light} !important`,
        },
        '&:hover': {
          backgroundColor: `${theme.palette['gray-background'].main} !important`,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
      {selected ? icon1 : icon2}
    </MenuItem>
  )
}

export default AdxMenuItem
